<template>
    <div>
        <div v-if="cardDecks.length">
            <div class="d-flex flex-row mt-3 align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                    <form-input class="me-2" style="min-width: 320px" v-model="filters.query" placeholder="Search for a Card Deck"
                                @keypress.enter="search">
                        <template slot="prepend">
                            <inline-svg src="/assets/img/icons/search-icon.svg"></inline-svg>
                        </template>
                    </form-input>
                    <span>View</span>
                    <form-select class="ms-1 me-2"
                                 style="margin-right: 20px"
                                 v-model="filters.category"
                                 @change="search"
                                 :options="categoryFilterOptions"
                    />
                </div>
                <!--            <btn-group-toggle :options="[-->
                <!--                    {'label': 'Sort by date', 'value': 'by_date'},-->
                <!--                    {'label': 'Sort by unpublished', 'value': 'by_unpublished'}-->
                <!--                    ]" v-model="filters.sort" @input="getData">-->
                <!--            </btn-group-toggle>-->
            </div>
            <div class="deck-card-list"  :class="{'loading' : loading.data}">
                <deck-card-hero v-for="cardDeck in cardDecks"
                                :cardDeck="cardDeck"
                                @onViewCards="handleViewCards"
                                :hero-name="heroName">
                </deck-card-hero>
            </div>
            <card-deck-cards-modal :cardDeck="selectedCardDeck" :hideBtn="true"></card-deck-cards-modal>
        </div>
        <no-card-decks v-else-if="!loading.data">
            <btn class="btn-outline-primary" @click="$router.push({ name: 'community.library'})">
                Go to Community Library
            </btn>
            <btn class="btn-primary" @click="redirectToAddCardDeck">
                <inline-svg class="me-1" src="/assets/img/icons/file-plus-01.svg"></inline-svg>
                Create a New Card Deck
            </btn>
        </no-card-decks>
    </div>
</template>

<script>

import BtnGroupToggle from "@/components/core/BtnGroupToggle.vue";
import {modelListMixin} from "/src/mixins/modelListMixin.js";
import CardDeckCardsModal from "@/views/CardDecks/CardDeckCardsModal.vue";
import DeckCardHero from "@/components/DeckCardHero.vue";
import NoCardDecks from "@/components/NoCardDecks.vue";

export default {
    name: "HeroCardDecks",
    components: {NoCardDecks, DeckCardHero, BtnGroupToggle, CardDeckCardsModal},
    mixins: [modelListMixin],
    props: ['heroName'],
    data() {
        return {
            filters: {
                category: '',
            },
            loading: {
                data: false,
            },
            cardDecks: [],
            selectedCardDeck: [],
            categoryFilterOptions: []
        }
    },
    mounted() {
        this.getData();
        this.getCategories();
        this.$events.$on('loadHeroCardDecks', () => {
            this.getData();
        });
    },
    methods: {
        getData() {
            this.loading.data = true;
            this.filters.hero_id = this.$route.params.hero_id;
            this.$http.post("/hero/card-decks", this.filters)
                .then((res) => {
                    this.cardDecks = res.body.data;
                    this.loading.data = false;
                })
                .catch((error) => {
                    this.loading.data = false;
                });
        },
        handleViewCards(cardDeck) {
            this.selectedCardDeck = cardDeck;
            this.$modal.show('viewCardsModal')
        },
        getCategories() {
            this.$http.get("/category/all")
                .then((res) => {
                    this.categories = res.body.data.categories;
                    this.categoryFilterOptions = res.body.data.categories.slice();
                    this.categoryFilterOptions.unshift({label: 'All Card Decks', value: null});
                })
                .catch((error) => {
                    console.log(error)
                });

        },
        redirectToAddCardDeck() {
            if (this.$route.name === 'card.decks') {
                this.$modal.show('addCardModal')
            } else {
                this.$router.push({ name: 'card.decks', params: {openAddCardDeck: 'open'}})
            }
        }
    }
}
</script>

<style scoped>

</style>
